import { useSelector } from "react-redux";
import "../../style/mobile/calendar/MEvents.scss";

const MEvents = () => {
  // const [eventList,setEventList] = useState([
  //   {
  //     id:1,
  //     title:"آزمون فلسفه زندگی",
  //     time:'11:00'
  //   },
  //   {
  //     id:2,
  //     title:"آزمون موسیقی شناسی",
  //     time:'18:00'
  //   },
  // ])

  const state = useSelector((state) => state.default);
  console.log(state.CalendarSelectedDay);
  // const [eventList,setEventList] = useState(state.CalendarEventList);
  console.log(state.CalendarEventList);
  return (
    <div className="MEvents">
      <div className="MEvents-title-box">
        <div className="MEvents-title-box-date">
          {state.CalendarSelectedDay.year}/{state.CalendarSelectedDay.month}/
          {state.CalendarSelectedDay.day}
        </div>
        <div className="MEvents-title-box-text">رویدادها</div>
      </div>
      <div className="MEvents-body">
        {state.CalendarEventList.map((item) => (
          <div key={item.id} className="MEvents-body-item">
            <div className="MEvents-body-item-name">{item.name}</div>
            <div className="MEvents-body-item-time">{item.time}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MEvents;